<template>
  <div>
    <div class="orders" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
      <div class="left-sidebar">
        <div class="left-sidebar__header">
          <img src="/static/img/pictos/commande.svg" class="">
          <span>Mes commandes</span>
        </div>
        <a :class="'left-sidebar__link left-sidebar__link--current visibility--' + current" @click.prevent="current = 1; getItems()" href="">
          <span><strong>Mes commandes en cours</strong> ({{ currentItems.length }})</span>
          <img src="/static/img/pictos/moins.svg" v-if="current == 1">
          <img src="/static/img/pictos/plus.svg" v-else>
        </a>
        <a :class="'left-sidebar__link left-sidebar__link--old visibility--' + current" @click.prevent="current = 0; getItems()" href="">
          <span><strong>Mes anciennes commandes</strong> ({{ oldItems.length }})</span>
          <img src="/static/img/pictos/moins.svg" v-if="current == 0">
          <img src="/static/img/pictos/plus.svg" v-else>
        </a>
      </div>
      <div class="content-area">
        <backlink/>
        <h1 v-if="current == 1">Mes commandes en cours</h1>
        <h1 v-else>Mes anciennes commandes</h1>
        <div class="filters">
          <select class="filter">
            <option value="">Trier par date</option>
            <option value="">Trier par statut</option>
          </select>
          <input class="filter" type="text" name="" placeholder="Rechercher par technicien" @keyup="searchFilter()">
        </div>
        <div class="orders__list">
          <Order v-for="item in filteredItems" :item="item"  v-if="current == 1" :key="item.id"></Order>
          <Order v-for="item in filteredItems" :item="item"  v-else :key="item.id"></Order>
        </div>
      </div>
    </div>
    <div class="orders orders--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <OrderHeader></OrderHeader>
      <div class="content-area content-area--mobile">
        <a class="left-sidebar__link left-sidebar__link--current active left-sidebar__link--mobile" @click.prevent="displayCurrent = !displayCurrent;">
          <span><strong>Mes commandes en cours</strong> ({{ currentItems.length }})</span>
          <img v-if="displayCurrent" src="/static/img/pictos/moins.svg">
          <img v-else src="/static/img/pictos/plus.svg">
        </a>
        <div class="orders__list" v-show="displayCurrent == 1">
          <Order v-for="item in currentItems" :item="item" :key="item.id" class="order--mobile"></Order>
        </div>
        <a class="left-sidebar__link left-sidebar__link--old left-sidebar__link--mobile" @click.prevent="displayOld = !displayOld;">
          <span><strong>Mes anciennes commandes</strong> ({{ oldItems.length }})</span>
          <img v-if="displayOld" src="/static/img/pictos/moins.svg">
          <img v-else src="/static/img/pictos/plus.svg">
        </a>
        <div class="orders__list" v-show="displayOld == 1">
          <Order v-for="item in oldItems" :item="item" class="order--mobile" :repass="true" :key="item.id"></Order>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import OrderHeader from "@/components/Order/OrderHeader";
import Order from "@/components/Order/Order";

export default {
  name: "OrderList",
  data() {
    return {
      current: 1,
      items: [],
      currentItems: [],
      oldItems: [],
      filteredItems: [],
      displayCurrent: 1,
      displayOld: 0,
    };
  },
  created(){
    this.$store.dispatch('showLoader');
    this.$store.dispatch("order/getMyOrders").then(() => {
      this.getItems();
      this.$store.dispatch('hideLoader');
    });
  },
  computed: {

  },
  mounted() {
    this.$store.dispatch('showLoader');

    this.$store.dispatch("order/getMyOrders").then(() => {
      this.getItems();
      this.$store.dispatch('hideLoader');
    });
  },
  methods: {
    searchFilter(){
      let searched = event.target.value;
      const self = this
      const regex = new RegExp(searched.toLowerCase().replace(/\s/g, ".*"), "gi");
      if(self.current == 1){
        this.filteredItems = self.currentItems.filter(item => {
          if(item.created_for_user.firstname.toLowerCase().match(regex)){
            return item
          }
        })
      }else{
        this.filteredItems = self.oldItems.filter(item => {
          if(item.created_for_user.firstname.toLowerCase().match(regex)){
            return item
          }
        })
      }
    },
    getItems(){
      this.items = this.$store.getters["order/getMyOrders"];

      this.currentItems = this.items.filter(function(i) { return i.status != 5 });
      this.oldItems = this.items.filter(function(i) { return i.status == 5 });

      if(this.current == 1){
        this.filteredItems = this.currentItems;
      }else{
        this.filteredItems = this.oldItems;
      }

    },
  },
  components: {
    ProductFamilyList,
    OrderHeader,
    Order
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisclair;
    border-radius: 20px;
    height: 5px;
  }

  .orders{ display: flex;
    &--mobile{ flex-direction: column;
      .left-sidebar__link{ margin-top: 0;
        &:last-of-type{ margin-top: 0; }
        &.active{
          &:after{ content: none; }
        }
      }
    }
  }
  .left-sidebar{ width: 300px;
    &__header{ background-color: $color3; display: flex; height: 300px; flex-direction: column; align-items: center; justify-content: center;
      img{ width: 100px; margin-left: 35px; }
      span{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; margin-top: 25px; text-transform: uppercase; }
    }
    &__link{ height: 75px; display: flex; color: white; padding: 0 20px; flex-direction: row; align-items: center; justify-content: space-between; position: relative;
      &:after{ content: ""; position: absolute; right: -10px; width: 0; height: 0; border-style: solid; border-width: 10px 0 10px 10px;  }
      &--current{ background-color: $color2;
        &.visibility--1{
          &:after{ border-color: transparent transparent transparent $color2; }
        }
      }
      &--old{ background-color: $color1;
        &.visibility--0{
          &:after{ border-color: transparent transparent transparent $color1; }
        }
        &.visibility--1{
          &:after{ content: none; }
        }
      }
      &--mobile{
          &:after{ content: none; }
      }
      img{ width: 20px; }
      span{ color: white; font-size: 14px;
        strong{ font-family: 'ClanProBold'; }
      }
      &:hover{ text-decoration: none; }
    }
  }
  .content-area{ width: calc(100% - 300px); padding: 0 7%; margin-top: 0;
    h1{ font-family: 'ClanFFBlack'; color: $color2; font-size: 25px; margin-bottom: 50px; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $color2; border-radius: 4px; position: absolute; bottom: 0; }
    }
    .orders__list{ overflow: auto; height: 500px; padding-right: 20px; }
    &--mobile{ width: 100%; padding: 0; margin-top: 0;
      .orders__list{ height: auto; padding: 20px 0 0 0; }
    }
  }
  .filters{ display: flex; margin-bottom: 50px;
    .filter{ height: 35px; line-height: 35px;  border: 1px solid $color1; }
    input[type=text]{ margin-left: 10px; width: auto; flex: 1; padding: 0 15px; font-size: 12px; }
    select{ width: 150px; font-size: 12px; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderList.vue